<template>
  <div class="c-key-aleatory">
    <label for="evp" class="title">Informe sua chave aleatória</label>

    <div class="field-body column is-full">
      <div class="field">
        <div class="control">
          <input
            id="evp"
            class="input has-value"
            placeholder="chave aleatória"
            name="evp"
            type="text"
            autocomplete="off"
            v-model.lazy="evp"
            @change="updateValue"
          />
          <i class="bar"></i>
          <p v-if="validation.hasError('evp')" class="help is-error">
            Por favor, revise a chave aleatória informada.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleVueValidator from 'simple-vue-validator'

const Validator = SimpleVueValidator.Validator

export default {
  mixins: [SimpleVueValidator.mixin],

  data() {
    return {
      evp: '',
    }
  },

  validators: {
    evp: (value) => {
      return Validator.value(value)
        .required()
        .regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
    },
  },

  computed: {
    hasErrors() {
      return this.validation.hasError('evp')
    },
  },

  methods: {
    async updateValue() {
      await this.$validate()
      this.$emit('change', {
        key: this.evp,
        error: this.hasErrors,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-key-aleatory {
  .title {
    margin-bottom: 40px;
    font-size: 20px;
    line-height: 100%;
    font-weight: bold;
    color: $gray-7;
  }

  .another-key {
    cursor: pointer;
    font-size: 18px;
    font-weight: 700;
    line-height: 21.6px;
    color: $support;
    margin-bottom: 50px;
    i {
      margin-left: 4px;
      font-size: medium;
    }
  }

  input {
    color: $neutral !important;
    font-size: 20px;
    font-weight: 700;
    line-height: 100%;
  }

  .field-body {
    padding-left: 0;
    margin-bottom: 50px;
  }
}
</style>
